import { CommonModule } from '@angular/common';
import { Component, HostListener } from '@angular/core';
import { BenefitsService } from 'src/app/core/services/benefits.service';
import { CommonService } from 'src/app/core/services/common.service';
import { BannerDocument, StyleContentSectionBenefit } from 'src/app/shared/models/styleContent';

@Component({
  selector: 'app-section-banners',
  standalone: true,
  imports: [
    CommonModule
  ],
  templateUrl: './section-banners.component.html',
  styleUrl: './section-banners.component.scss'
})
export class SectionBannersComponent {

  url: string

  isMobile = window.innerWidth < 768;
  public styles: { [key: string]: any };
  banners: { url: string; link: string | null }[] = [];
  carouselType: any;
  carouselInterval: any;

  constructor(
    private benefitsService: BenefitsService,
    private commonService: CommonService
  ) { }

  @HostListener('window:resize', ['$event'])
  onResize(event: Event) {
    this.isMobile = (event.target as Window).innerWidth < 768;
  }

  ngOnInit(): void {
    this.getBannerConfig();
  }

  getBannerConfig() {
    this.benefitsService.getBannerConfig().subscribe((response: StyleContentSectionBenefit) => {
      let benefitSecResp = response;
      this.getBanners(response.bannerDocuments);
      this.url = this.commonService.getImageStr(benefitSecResp?.banner?.id)
      this.setStyles(benefitSecResp);
    });
  }

  getBanners(documents: BannerDocument[] | null | undefined) {
    (documents ?? []).forEach((d: BannerDocument) => {
      if (!d?.document) {
        return;
      }
      this.banners.push({
        url: this.commonService.getImageStr(d.document.id),
        link: d.link || null
      });
    });
  }

  setStyles(styles: StyleContentSectionBenefit) {
    this.carouselType = styles.carouselType;
    this.carouselInterval = styles.carouselInterval;
    this.styles = {
      '--show-section': styles.showSection ? 'block' : 'none',
      '--background-image': styles.backgroundIsImage ? `url(${this.commonService.getImageStr(styles.document?.id)})` : 'none',
      '--background-color': styles.backgroundColor,
      '--side-buttons-color': styles.sideButtonsColor,
      '--side-buttons-icon-color': styles.sideButtonsIconColor === 'true' ? '#000' : '#fff'
    };
  }

}
